import { useState, useEffect } from "react"
import PropTypes from "prop-types"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import OnboardingTile from "./onboarding_tile"
import Header from "./header"

import android from "images/icons/android.svg"
import apple from "images/icons/apple.svg"
import web from "images/icons/web.svg"

import "./index.scss"

const PlatformSelection = ({ onPlatformSelected, images }) => {
  const platforms = [
    {
      name: "Android",
      icon: android,
      color: "#073042",
      backgroundStyle: `center / cover url(${images.android})`,
    },
    {
      name: "iOS",
      icon: apple,
      backgroundStyle: `center / cover url(${images.apple})`,
    },
    {
      name: "Web",
      icon: web,
      backgroundStyle:
        "linear-gradient(126.88deg, #1DE5DB 11.43%, #006DE3 98.14%)",
    },
  ]

  useEffect(() => {
    logIFTTTNextAction("page_viewed", {
      location_type: "preferred_platform_prompt",
    })
  }, [])

  const [selectedPlatforms, setSelectedPlatforms] = useState(new Set())

  const onSelect = platformName => {
    const platforms = new Set(selectedPlatforms)
    if (platforms.has(platformName)) {
      platforms.delete(platformName)
    } else {
      platforms.add(platformName)
    }
    setSelectedPlatforms(platforms)
  }

  const onContinue = () => {
    logIFTTTNextAction("statechange", {
      location_type: "preferred_platform_prompt",
      object_type: "preferred_platforms",
      object_id: [...selectedPlatforms]
        .map(p => p.toLowerCase())
        .sort()
        .join(","),
    })
    onPlatformSelected()
  }

  return (
    <>
      <Header title="Let's start!" />
      <div styleName="container platform-selection">
        <div>
          <p className="txt-body-3">
            Where do you usually set up your automations?
            <br />
            This is important so we can find the best Applets for you.
          </p>
          <ul styleName="service-list">
            {platforms.map(p => (
              <li key={p.name}>
                <OnboardingTile
                  onClick={() => onSelect(p.name)}
                  onboardingItem={p}
                  selected={selectedPlatforms.has(p.name)}
                  isPlatformSelect
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {selectedPlatforms.size > 0 && (
        <div styleName="platform-selection-continue">
          <button onClick={onContinue} className="button-primary">
            Continue
          </button>
        </div>
      )}
    </>
  )
}

PlatformSelection.propTypes = {
  onPlatformSelected: PropTypes.func.isRequired,
  images: PropTypes.object.isRequired,
}

export default PlatformSelection
